module.exports = __webpack_public_path__ + "img/esfp.bb4a5348.png";